<p *ngIf="showDas2Banner" [class.diary-banner]="diaryBanner === true" class="das-2-banner">
  <mat-icon>warning</mat-icon>DAS 2.0 compatibility mode
</p>
<p *ngIf="showSnapshotBanner" class="snapshot-banner"><mat-icon>party_mode</mat-icon>Viewing snapshot</p>
